export default {"src":"/customer-services/_next/static/media/protect-plus.06231b05.svg","height":36,"width":202,"blurWidth":0,"blurHeight":0};